module.exports = __webpack_public_path__ + "img/WORD.d023c744.png";